import { render, staticRenderFns } from "./VideoForm.vue?vue&type=template&id=6f9530a8&scoped=true"
import script from "./VideoForm.vue?vue&type=script&lang=js"
export * from "./VideoForm.vue?vue&type=script&lang=js"
import style0 from "./VideoForm.vue?vue&type=style&index=0&id=6f9530a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9530a8",
  null
  
)

export default component.exports